const PageText = {
    NEXT: "Next",
    SIGN_UP_SIGN_IN: "Sign Up or Sign In",
    JOIN_NOW: "Join Now",
    REGISTER_SUCCESS: "You're now signed in. Please check your email for a link to validate your email address.",
    CHOOSE_INDUSTRY: "Choose your industry to help us deliver you more relevant articles and videos.",
    TERMINAL_REGISTER: "Register",
    TERMINAL_LINK_SUBTITLE: "Connect with Bloomberg Terminal to access Businessweek online",
    LOGINREGISTER_SUBTITLE: "Never miss a thing with free newsletters and your Bloomberg Watchlist",
    FEATURE_SUBTITLE: "Access all the best Bloomberg.com has to offer.",
    MAGAZINE_SUBTITLE: "Link your Businessweek subscription to a Bloomberg account for unlimited access across the Businessweek site and app",
    CONNECT: "Connect",
    SUBSCRIPTION_HELP: "Need help linking your subscription?",
    BUSINESSWEEK_REGISTER: "Complete Registration",
    SIGN_IN: "Sign In",
    SIGN_IN_SUBTITLE: "Welcome back! Enter your password to access your Bloomberg.com account.",
    CREATE_ACCOUNT: "Create an Account",
    CREATE_ACCOUNT_SUBTITLE: "It looks like you’re new here. Set a password to create your account.",
    FORGOT_PASSWORD_TITLE: "Reset your Password",
    FORGOT_PASSWORD_SUBTITLE: "Enter your email address and we'll email you a link to reset your password.",
    RESET_PASSWORD_SUBTITLE: "Choose a new password",
    MY_SUBSCRIPTIONS: "Subscriptions"
};

export default PageText;
